export const getProductDescription = (id: string | number | undefined) => ({
  type: "@saga/GET_PRODUCT_DESCRIPTION",
  payload: id,
});
